import type { FieldType } from './index.ts'

const nullFilterTypes = ['null', 'not_null'] as const
const blankFilterTypes = ['blank', 'present'] as const
export const equalFilterTypes = ['equal', 'not_equal'] as const
export const inFilterTypes = ['in', 'not_in'] as const
export const overlapFilterTypes = ['overlap', 'not_overlap'] as const
// eslint-disable-next-line sonarjs/todo-tag
// TODO: betweenはUI実装が面倒になるので、一旦除外
export const includeFilterTypes = ['include', 'not_include'] as const
export const startsWithFilterTypes = ['starts_with', 'not_starts_with'] as const
const comparableFilterTypes = ['less_than', 'less_than_or_equal', 'greater_than', 'greater_than_or_equal'] as const
const equalMeFilterTypes = ['equal_me'] as const

export const booleanFilterTypes = [...equalFilterTypes, ...nullFilterTypes] as const
export const stringFilterTypes = [
  ...equalFilterTypes,
  ...inFilterTypes,
  ...nullFilterTypes,
  ...includeFilterTypes,
  ...startsWithFilterTypes,
  ...blankFilterTypes,
  ...equalMeFilterTypes,
] as const
export const numericFilterTypes = [
  ...equalFilterTypes,
  ...comparableFilterTypes,
  ...nullFilterTypes,
  ...inFilterTypes,
] as const
export const dateFilterTypes = [...equalFilterTypes, ...comparableFilterTypes, ...nullFilterTypes] as const
export const timeFilterTypes = [...equalFilterTypes, ...comparableFilterTypes, ...nullFilterTypes] as const
export const arrayFilterTypes = [
  ...nullFilterTypes,
  ...overlapFilterTypes,
  ...includeFilterTypes,
  ...inFilterTypes,
] as const
export const filterTypes = [
  ...equalFilterTypes,
  ...nullFilterTypes,
  ...inFilterTypes,
  ...includeFilterTypes,
  ...startsWithFilterTypes,
  ...overlapFilterTypes,
  ...comparableFilterTypes,
  ...blankFilterTypes,
  ...equalMeFilterTypes,
] as const

export type BooleanFiltersType = typeof booleanFilterTypes
export type StringFiltersType = typeof stringFilterTypes
export type NumericFiltersType = typeof numericFilterTypes
export type DateFiltersType = typeof dateFilterTypes
export type TimeFiltersType = typeof timeFilterTypes
export type ArrayFiltersType = typeof arrayFilterTypes
export type FiltersType = typeof filterTypes

export type BooleanFilterType = BooleanFiltersType[number]
export type StringFilterType = StringFiltersType[number]
export type NumericFilterType = NumericFiltersType[number]
export type DateFilterType = DateFiltersType[number]
export type TimeFilterType = TimeFiltersType[number]
export type ArrayFilterType = ArrayFiltersType[number]
export type FilterType = FiltersType[number]

// export const DEFAULT_TIMEZONE_INTERVAL = '+9 hours'
export type TimezoneInterval = `+9 hours` // これ以外にも対応する必要ができたら、template literal typesを使って対応

// eslint-disable-next-line sonarjs/todo-tag
// TODO: rename
export interface AlwaysFilter {
  field_name: string // lookerに習ってfield_nameとしたが、実質sql
  field_type: FieldType
  filter_type: FilterType
  filter_expression?: string | number
}
